//
// Copyright 2026 DXOS.org
//
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_dxos_halo_credentials } from "./credentials_pb.js";
import { file_dxos_keys } from "../keys_pb.js";
/**
 * Describes the file dxos/halo/inbox.proto.
 */
export const file_dxos_halo_inbox = /*@__PURE__*/ fileDesc("ChVkeG9zL2hhbG8vaW5ib3gucHJvdG8SD2R4b3MuaGFsby5pbmJveCKlAQoNSW5ib3hFbnZlbG9wZRIPCgd2ZXJzaW9uGBAgASgNEg4KBmhlYWRlchgRIAEoDBIkCgZzaWduZXIYEiABKAsyFC5keG9zLmtleXMuUHVibGljS2V5EhEKCXNpZ25hdHVyZRgTIAEoDBIwCgVjaGFpbhgUIAEoCzIcLmR4b3MuaGFsby5jcmVkZW50aWFscy5DaGFpbkgAiAEBQggKBl9jaGFpbiLBAQoTSW5ib3hFbnZlbG9wZUhlYWRlchIPCgd2ZXJzaW9uGAEgASgNEgwKBHR5cGUYAiABKAkSJAoGc2VuZGVyGAMgASgLMhQuZHhvcy5rZXlzLlB1YmxpY0tleRInCglyZWNpcGllbnQYBCABKAsyFC5keG9zLmtleXMuUHVibGljS2V5EisKB3NlbnRfYXQYBSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEg8KB3BheWxvYWQYBiABKAlCMFouZ2l0aHViLmNvbS9keG9zL2R4b3MvcHJvdG8vZGVmL2R4b3MvaGFsby9pbmJveGIGcHJvdG8z", [file_google_protobuf_timestamp, file_dxos_halo_credentials, file_dxos_keys]);
/**
 * Describes the message dxos.halo.inbox.InboxEnvelope.
 * Use `create(InboxEnvelopeSchema)` to create a new message.
 */
export const InboxEnvelopeSchema = /*@__PURE__*/ messageDesc(file_dxos_halo_inbox, 0);
/**
 * Describes the message dxos.halo.inbox.InboxEnvelopeHeader.
 * Use `create(InboxEnvelopeHeaderSchema)` to create a new message.
 */
export const InboxEnvelopeHeaderSchema = /*@__PURE__*/ messageDesc(file_dxos_halo_inbox, 1);
//# sourceMappingURL=inbox_pb.js.map